import React from "react";
import { QRCodeCanvas } from "qrcode.react";

const QR = () => {
  return <QRCodeCanvas value="https://qr-efbc6.web.app/" />;
};

export default QR;
